// extracted by mini-css-extract-plugin
export default {"root":"IconSettingsDots_root__to0I8","rootMargin":"IconSettingsDots_rootMargin__4SeMQ"};